<template>
  <!-- /*  提供多级菜单的容器 */ -->
  <keep-alive :include="tabNames">
    <router-view :key="key" />
  </keep-alive>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'LayoutPageRoute', // 必须命名
  data() {
    return {
      from: {},
      to: {}
    };
  },
  watch: {
    $route(route, oldRoute) {}
  },
  computed: {
    ...mapGetters({
      tabNames: 'tabs/tabNames'
    }),
    key() {
      return this.$route.fullPath;
    }
  },
  mounted() {}
};
</script>
